import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
export { Input } from './components/Input';
export { Textfield } from './components/Textfield';
export { Switch } from './components/Switch';
export { default as Checkbox, CheckboxIcon } from './components/Checkbox';
export { Radio, RadioIcon } from './components/Radio';
const TextArea = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("textarea", Object.assign({}, props, { ref: ref, className: clsx('textarea-field', className) })));
});
TextArea.displayName = 'TextArea';
const FormGroup = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({}, props, { ref: ref, className: clsx('form-group', className) })));
});
FormGroup.displayName = 'FormGroup';
const Required = () => React.createElement("span", { className: 'mx-1 text-danger' }, "*");
const FormError = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({}, props, { ref: ref, className: clsx('form-error', className) })));
});
FormError.displayName = 'FormError';
const Error = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({}, props, { ref: ref, className: clsx('form-error', className) })));
});
Error.displayName = 'Error';
const FormFeedback = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({}, props, { ref: ref, className: clsx('form-feedback', className) })));
});
FormFeedback.displayName = 'FormFeedback';
const FormHint = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({}, props, { ref: ref, className: clsx('form-hint', className) })));
});
FormHint.displayName = 'FormHint';
const FormLabel = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({}, props, { ref: ref, className: clsx('form-label', className) })));
});
FormLabel.displayName = 'FormLabel';
const Label = React.forwardRef((props, ref) => React.createElement("label", Object.assign({}, props, { ref: ref })));
Label.displayName = 'Label';
export { TextArea, FormGroup, Required, FormError, Error, FormFeedback, FormHint, FormLabel, Label, };
//# sourceMappingURL=index.js.map